import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { showToast } from '../context/ToastHandle';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = searchParams.get('session_id');

    const verifyAndSync = async () => {
      if (!sessionId) return;

      try {
        const res = await api.post('/verify-session.php', {
          session_id: sessionId
        });

        const newToken = res.data.token;
        if (newToken) {
          localStorage.setItem('token', newToken);
          showToast('Subscription updated successfully!', 'success', false);
        } else {
          showToast('Subscription verified, but token missing.', 'warning', false);
        }
      } catch (err) {
        showToast('Failed to verify payment.', 'error', false);
      }

      setTimeout(() => navigate('/'), 2000);
    };

    verifyAndSync();
  }, [searchParams, navigate]);

  return (
    <div className="payment-message">
      <h1>Thank you!</h1>
      <p>Your payment was successful. Syncing your account...</p>
    </div>
  );
};

export default PaymentSuccess;
